import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const TESTING_PROGRAM_TABLE_STATE_STORAGE_KEY = "userTestingProgramList";

export const TESTING_PROGRAM_LIST_COLUMN_IDS = {
    NAME: "name",
    ACCESS_RIGHT: "accessRight",
} as const;

export const testingProgramListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: TESTING_PROGRAM_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const testingProgramListColumnFiltersCodecMap = {
    [TESTING_PROGRAM_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
    [TESTING_PROGRAM_LIST_COLUMN_IDS.ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
};
